
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./housemaamaas.css";
import "./Style.css";

const SidescrollAdvertisements = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);
  const [companies, setCompanies] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const scrollRef = useRef(null);
  const scrollIntervalRef = useRef(null);
  const navigate = useNavigate();

  // 🔹 Resize handler
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1000);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔹 Image helper
  const toImageSrc = (raw) => {
    if (!raw || raw.trim() === "" || raw.trim() === "/")
      return "/placeholder.svg";
    if (raw.startsWith("data:image/")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.length > 1000 && /^[A-Za-z0-9+/=]/.test(raw)) {
      return `data:image/png;base64,${raw}`;
    }
    return ` https://backend.maamaas.com/food/api/${raw}`;
  };

  // 🔥 FETCH DISCOUNT DISHES (CORRECTED)
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");
    if (!token) {
      setCompanies([]);
      return;
    }

    axios
      .get(` https://backend.maamaas.com/food/api/dish/discount/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const dishArray = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];

        // ✅ map + strict discount validation
        const validDishes = dishArray
          .map((item) => {
            const discountValue = Number(item.discount);
            return {
              ...item,
              image: toImageSrc(item.dishImage),
              discount: discountValue,
              companyName: item.companyName || "Maamaas",
            };
          })
        // ❌ remove 0 / NaN / null discounts
        // .filter(
        //   (item) =>
        //     !isNaN(item.discount) && item.discount > 0
        // );

        // ✅ UNIQUE COMPANY ONLY
        const uniqueCompanies = [];
        const companySet = new Set();

        validDishes.forEach((dish) => {
          if (!companySet.has(dish.companyName)) {
            companySet.add(dish.companyName);
            uniqueCompanies.push(dish);
          }
        });

        setCompanies(uniqueCompanies);
      })
      .catch((err) => {
        console.error("Error fetching dishes:", err);
        setCompanies([]);
      });
  }, []);

  // 🔄 Auto Scroll (UNCHANGED – already correct)
  useEffect(() => {
    const startAutoScroll = () => {
      if (scrollRef.current && !scrollIntervalRef.current) {
        scrollIntervalRef.current = setInterval(() => {
          if (scrollRef.current && !isHovered) {
            const el = scrollRef.current;
            el.scrollTop += 1;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
              el.scrollTop = 0;
            }
          }
        }, 30);
      }
    };

    const stopAutoScroll = () => {
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
    };

    startAutoScroll();
    return stopAutoScroll;
  }, [isHovered]);

  // 🔹 Click handler
  const handleCompanyClick = (dish) => {
    const vendorId = dish.vendorId || dish.companyId;
    if (!vendorId) return;

    localStorage.setItem("vendorId", vendorId);
    navigate(`/allorderaccepts/${vendorId}`);
  };

  const getGradientByDiscount = (percentage) => {
    if (percentage >= 50)
      return "linear-gradient(135deg, #ff416c, #ff4b2b)";
    if (percentage >= 30)
      return "linear-gradient(135deg, #ee6521, #764ba2)";
    return "linear-gradient(135deg, rgba(18, 20, 21, 1), rgba(18, 20, 21, 0))";
  };

  return (
    <div className="container-fluid">
      <div className="row ms-0">
        <div
          className="col-lg-3"
          style={{ display: isMobile ? "none" : "block", paddingRight: "0px" }}
        >
          <div
            className="scroll-fixed-data mobilescroll sidebar-box my-sidebar"
            style={{
              position: "fixed",
              right: "10px",
              top: "67px",
              borderRadius: "12px",
              padding: "15px",
              marginTop: "30px",
              width: "280px",
            }}
          >
            <div
              ref={scrollRef}
              style={{
                maxHeight: "700px",
                overflowY: "auto",
                paddingRight: "5px",
                scrollbarWidth: "none",
              }}
              className="hide-scrollbar"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {companies.length > 0 ? (
                companies.map((dish, index) => (
                  <div
                    key={`${dish.companyName}-${index}`}
                    className="coupon-card"
                    style={{
                      width: "100%",
                      height: "150px",
                      marginBottom: "15px",
                      backgroundImage: dish.image
                        ? `url(${dish.image}), ${getGradientByDiscount(dish.discount)}`
                        : getGradientByDiscount(dish.discount),
                      backgroundSize: "cover, cover",
                      backgroundPosition: "center, center",
                      backgroundBlendMode: "overlay",
                      borderRadius: "12px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      position: "relative",
                    }}
                    onClick={() => handleCompanyClick(dish)}
                  >
                    <div
                      style={{
                        borderRadius: "12px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "rgba(0,0,0,0.3)",
                        padding: "15px",
                        textAlign: "center",
                      }}
                    >
                      {/* Company Name */}
                      <h5
                        style={{
                          margin: "0 0 4px 0",
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        {dish.companyName}
                      </h5>

                      {/* Discount */}
                    
                        <p style={{ margin: "0 0 4px 0", color: "#fff", fontSize: "22px", fontWeight: "bold", }} > FLAT {dish.discount}% OFF </p>
                     


                      <p
                        style={{
                          margin: "8px 0 0 0",
                          color: "rgba(255,255,255,0.8)",
                          fontSize: "10px",
                          fontStyle: "italic",
                        }}
                      >
                        Click to See More
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#718096",
                  }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "10px" }}>
                    🎁
                  </div>
                  <p style={{ fontWeight: "600" }}>No Offers available</p>
                  <p style={{ marginTop: "5px", fontSize: "14px" }}>
                    Check back later!
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidescrollAdvertisements;